import { SrPartialPackingTypeMap } from '@plato/data/starrocks/types';

function checkQuantityForRounding(
    quantity: number | null,
    salesUnitsPerPackageUnit: number,
    partialPackingType: SrPartialPackingTypeMap,
) {
    if (quantity === null) {
        return quantity;
    }

    if (partialPackingType === SrPartialPackingTypeMap.NO_RESTRICTION) {
        return quantity;
    }

    let newQuantity: number;

    if (partialPackingType === SrPartialPackingTypeMap.ALWAYS_ROUND_DOWN) {
        newQuantity = Math.floor(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    } else if (partialPackingType === SrPartialPackingTypeMap.ALWAYS_ROUND_UP) {
        newQuantity = Math.ceil(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    } else {
        newQuantity = Math.round(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    }

    if (newQuantity === 0) {
        newQuantity = salesUnitsPerPackageUnit;
    }

    return newQuantity;
}

function showPackgingUnitModalFn(partialPackingType: SrPartialPackingTypeMap) {
    return [
        SrPartialPackingTypeMap.NO_PACKAGE_BREAK as string,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
    ].includes(partialPackingType);
}

export { checkQuantityForRounding, showPackgingUnitModalFn };
